<template>
  <div
    class="burger-icon"
    @click="onClick"
  >
    <img
      src="~/assets/icons/hamburger.svg"
      width="18"
      height="12"
      alt="Menu icon"
    />
  </div>
</template>

<script lang="ts" setup>
  const emit = defineEmits(['toggleMenu'])

  function onClick() {
    emit('toggleMenu')
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .burger-icon {
    position: relative;
    width: 18px;
    height: 18px;
    float: left;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    // @include bp-tablet-only {
    //   margin-left: rem(8);
    // }
  }
</style>
